import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPlaylistRecord } from "@src/types/playlist";
import { ITrack } from "@src/types/track";

export type ITrackStatus =
  | "idle"
  | "loading"
  | "ready"
  | "playing"
  | "paused"
  | "ended"
  | "error";
interface TrackPlayerState {
  trackURL: string;
  currentPlayingProcessedPlaylist: IPlaylistRecord | null;
  currentPlayingTrack: ITrack | null;
  trackStatus: ITrackStatus;
  isPlaying: boolean;
}

export const trackPlayerInitialState: TrackPlayerState = {
  trackURL: "",
  currentPlayingProcessedPlaylist: {
    id: 0,
    title: "",
    documentId: "",
    createdAt: "",
    updatedAt: "",
    publishedAt: "",
    playlistStatus: "draft",
    playlistPeaks: null,
    waveform: null,
    waveformBinary: null,

    overwriteShowDescription: null,
    overwriteShowRadioImage: null,
    playlistProcessing: false,
    soundcloudEmbedUrl: null,
    notes: null,
    tracksDuration: 0,
    show: {
      id: 0,
      documentId: "",
      title: "",
    },
    playlistProcessedAudio: {
      alternativeText: null,
      caption: null,
      createdAt: "",
      documentId: "",
      ext: "",
      formats: null,
      hash: "",
      height: null,
      id: 0,
      mime: "",
      name: "",
      previewUrl: null,
      provider: "",
      provider_metadata: null,
      publishedAt: "",
      size: 0,
      updatedAt: "",
      url: "",
      width: null,
    },
  },
  currentPlayingTrack: {
    audio: {
      url: "",
    },
    processedAudio: {
      url: "",
    },
    album: "",
    artist: "",
    audioFlacStarted: false,
    bitrate: 0,
    bpm: 0,
    createdAt: "",
    documentId: "",
    duration: 0,
    endBpm: null,
    endKey: null,
    fadeInTime: null,
    fadeOutTime: null,
    id: 0,
    isrc: "",
    key: "",
    label: "",
    metadata: null,
    notes: "",
    ownedByRovr: false,
    platform_search: undefined,
    publishedAt: "",
    sampleRate: undefined,
    spotify: undefined,
    title: "",
    trackInformation: undefined,
    updatedAt: "",
    year: "",
    youtube: undefined,
    trackPeaks: null,
  },
  trackStatus: "loading",
  isPlaying: false,
};

const librarySlice = createSlice({
  name: "trackPlayer",
  initialState: trackPlayerInitialState,
  reducers: {
    setCurrentPlayingTrack(state, action: PayloadAction<ITrack | null>) {
      state.currentPlayingTrack = action.payload;
      state.currentPlayingProcessedPlaylist = null;
      state.trackURL = action.payload?.audio?.url ?? "";
    },
    setCurrentPlayingProcessedPlaylist(
      state,
      action: PayloadAction<IPlaylistRecord | null>
    ) {
      state.currentPlayingProcessedPlaylist = action.payload;
      state.currentPlayingTrack = null;
      state.trackURL = action.payload?.playlistProcessedAudio?.url || "";
    },
    setIsPlaying(state, action: PayloadAction<boolean>) {
      state.isPlaying = action.payload;
    },
    setTrackStatus(state, action: PayloadAction<ITrackStatus>) {
      state.trackStatus = action.payload;
    },
  },
});

export const {
  setTrackStatus,
  setCurrentPlayingTrack,
  setCurrentPlayingProcessedPlaylist,
  setIsPlaying,
} = librarySlice.actions;

export default librarySlice.reducer;
